import React from 'react';

const UnderArmourTheme = {
  headerLogo: {
    src: '/themes/theme/underarmour/logo.png',
    alt: 'Under Armour influencers',
  },
  darkLogo: {
    src: '/themes/theme/underarmour/logo.png',
    alt: 'Under Armour influencers',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'UNDER ARMOUR | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="70" src="/themes/theme/underarmour/logo.png" alt="Under Armour Influencers" />
      <br />
    </div>
  ),
  shareSite: 'https://underarmourr.dyzio.co',
};

export default UnderArmourTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/underarmour.js
 **/